import { ModuleSelection, State } from './models';

export function hasAtLeastStarted(moduleSelection: ModuleSelection) {
  return [State.Started, State.Dischargable, State.Completed, State.Archived].includes(
    moduleSelection?.state
  );
}

export function hasAtLeastDischargable(moduleSelection: ModuleSelection) {
  return [State.Dischargable, State.Completed, State.Archived].includes(moduleSelection?.state);
}

export function isExactlyDischargable(moduleSelection: ModuleSelection) {
  return [State.Dischargable].includes(moduleSelection?.state);
}

export function thisModuleSelectionIsDeleteable(moduleState: State) {
  return [State.Inactive, State.Draft].includes(moduleState);
}
